import React, {memo} from "react"
import style from "styles/nftMechanism.module.css"
import useLocale from '../../../../hooks/useLocale'
import Angle from '../../../icons/Angle'

const NftFeatures = () => {
	const {nftMechanism} = useLocale()

	return (
		<div className={style.nft}>
			<div className={style.bg}>
				<video
					autoPlay={true}
					muted={true}
					loop={true}
					playsInline={true}
					className={style.video}
				>
					<source src="/video/mystery.mp4" type="video/mp4"/>
				</video>
				<div className={style.container}>
					<div className={style.content}>
						<div>
							<div
								data-aos-once="true"
								data-aos="fade-right"
								data-aos-offset="100"
								data-aos-easing="ease-in-sine"
								className={style.title}>{nftMechanism.title}</div>
							<div
								data-aos-once="true"
								data-aos="fade-left"
								data-aos-offset="100"
								data-aos-easing="ease-in-sine"
								className={style.subtitle}>{nftMechanism.subtitle}</div>
						</div>

						<div
							data-aos-once="true"
							data-aos="fade-down-right"
							data-aos-offset="100"
							data-aos-easing="ease-in-sine"
							className="absolute top-10 left-0"
						>
							<Angle />
						</div>

						<div
							data-aos-once="true"
							data-aos="fade-down-left"
							data-aos-offset="100"
							data-aos-easing="ease-in-sine"
							className="absolute top-10 right-0"
						>
							<Angle className="rotate-90"/>
						</div>

						<div
							data-aos-once="true"
							data-aos="fade-up-left"
							data-aos-anchor-placement="center"
							className="absolute bottom-28 right-0"
						>
							<Angle className="rotate-180"/>
						</div>

						<div
							data-aos-once="true"
							data-aos="fade-up-right"
							data-aos-anchor-placement="center"
							className="absolute bottom-28 left-0"
						>
							<Angle className="-rotate-90"/>
						</div>
					</div>
				</div>

				<div className={style.fade}/>
			</div>

			<div
				data-aos-once="true"
				data-aos="fade-left"
				data-aos-offset="100"
				data-aos-easing="ease-in-sine"
				className={[style.platforms, style.container].join(" ")}>
				<img alt="" src="/image/mystery/binance.svg" />
				<img alt="" src="/image/mystery/sphere.svg" />
				<img alt="" src="/image/mystery/kucoin.svg" />
				<img alt="" src="/image/mystery/huobi.svg" />
				<img alt="" src="/image/mystery/ghostMarket.svg" />
			</div>

			<div className={style.container}>
				<button
					data-aos-once="true"
					data-aos="fade-left"
					data-aos-offset="100"
					data-aos-easing="ease-in-sine"
					className={style.button}
					onClick={() => window.open('https://nft.metaisland.gg', '_blank')}>
					{nftMechanism.button}
				</button>
			</div>

			<div
				data-aos-once="true"
				data-aos="fade-left"
				data-aos-offset="100"
				data-aos-easing="ease-in-sine"
				className={style.container}>
				<div className={style.steps}>
					<div className={style.text}>{nftMechanism.firstStep}</div>
					<img alt="" src="/image/staking/step.svg"/>
					<div className={style.text}>{nftMechanism.secondStep}</div>
					<img alt="" src="/image/staking/step.svg"/>
					<div className={style.text}>{nftMechanism.thirdStep}</div>
				</div>
			</div>
		</div>
	)
}

export default memo(NftFeatures)
